/**
 * @copyright Copyright 2015-2019 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "mw-form/MenuItem",
    "MW/toolstrip/mixins/property/IconMixin",
    "MW/toolstrip/mixins/property/IconOverrideMixin",
    "MW/toolstrip/mixins/property/TypeMixin",
    "MW/toolstrip/mixins/property/DescriptionOverrideMixin",
    "MW/toolstrip/mixins/property/TextOverrideMixin",
    "MW/toolstrip/mixins/property/UseQuickAccessIconMixin",
    "MW/toolstrip/mixins/property/QuickAccessIconMixin",
    "MW/toolstrip/mixins/property/RemovableMixin",
    "mw-form/mixins/mixinDependencyValidator"

], function (declare, MenuItem, IconMixin, IconOverrideMixin, TypeMixin, DescriptionOverrideMixin, TextOverrideMixin,
    UseQuickAccessIconMixin, QuickAccessIconMixin, RemovableMixin, mixinDependencyValidator) {

    return declare(mixinDependencyValidator.validate([MenuItem, IconMixin, IconOverrideMixin, TypeMixin, DescriptionOverrideMixin,
        TextOverrideMixin, UseQuickAccessIconMixin, QuickAccessIconMixin, RemovableMixin]), {
        visualFamily: "default",

        _setRemovableAttr: function (value) {
            this.inherited(arguments);

            if (value) {
                this.domNode.classList.add("removableTrue");
                this._removeNode = document.createElement("div");
                this._removeNode.classList.add("mwRemoveNode");
                var removeIconNode = document.createElement("div");
                removeIconNode.classList.add("clear_all");
                this._removeNode.appendChild(removeIconNode);
                this.domNode.appendChild(this._removeNode);

                this._handleKeyupForRemove = function (e) {
                    // DELETE key
                    if (e.keyCode === 46) {
                        this._emitRemoveEvent();
                        e.stopPropagation();
                    }
                }.bind(this);

                this.domNode.addEventListener("keyup", this._handleKeyupForRemove);
                this._removeNode.addEventListener("click", this._handleRemoveNodeClick.bind(this));
                this._removeNode.addEventListener("mouseup", this._handleRemoveNodeMouseup);

                this.eligibleForParentAdditionToQAB = true; // Add parent to QAB when listItem is removable
            } else if (this._removeNode) {
                this.domNode.classList.remove("removableTrue");

                this.domNode.removeChild(this._removeNode);
                // This will also cleanup the listeners on the _removeNode
                this._removeNode = null;

                // The listener on the domNode needs to be explicitly removed
                this.domNode.removeEventListener("keyup", this._handleKeyupForRemove);

                this.eligibleForParentAdditionToQAB = false;
            }

            this._set("removable", value);
        },

        _handleRemoveNodeClick: function (e) {
            this._emitRemoveEvent();
            e.stopPropagation();
        },

        _handleRemoveNodeMouseup: function (e) {
            // Prevent popup from closing
            e.stopPropagation();
        }
    });
});
